import React from "react";
import { useDispatch } from "react-redux";
//import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { getHeaders, lmtdCheck } from "../../../../utils/common/index";
//import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';
//import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
//import LinearProgress from '@material-ui/core/LinearProgress';
import { ExportToCsv } from "export-to-csv";
import {
  fetchShowAlert,
  hideAlert,
} from "../../../../redux/actions/homeAction";
import { triggerFetchSalesCsv } from "../../../../redux/actions/homeAction";
import { salesCsvFilter } from "../../../../utils/common/csvMappings/deviceSalesCsv";
import CustomCardView from "../../../../views/deviceSales/sales/component/CustomCardView";
import { CustomSalesCard } from "../../../../components/customSalesCard/index";
const CustomCard = (props) => {
  const dispatch = useDispatch();
  //const classes = useStyles();
  const { data } = props;
  // const filterData = props.filterValue;
  let body = props.body;
  //const [downloadCsv, setDownloadCsv] = useState(false);
  // const [csvData, setCsvData] = useState([]);
  // const [isDownloaded, setIsDownloaded] = useState(false);
  // const { salesCsvObj } = useSelector(state => state.homeReducer);
  // const csvData = salesCsvObj && salesCsvObj.salesCsvData[csvUrl+'$'+data.brandType];
  function fetchCsvData(brandType) {
    //setDownloadCsv(true);
    body["extraHeaders"] = getHeaders(brandType);
    if (props.csvUrl.includes("activation") && brandType === "JIOFI") {
      body["extraHeaders"] = {
        ...body["extraHeaders"],
        model: "JIOFI",
      };
    }
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: props.csvUrl,
      },
      params: body,
      extraData: props.csvUrl,
      tab: brandType,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "DeviceSales_sales",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerFetchSalesCsv(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData = salesCsvFilter(
            props.tileName,
            props.body.partnerRoleType,
            props.subTileName === "JIO BHARAT" ? "JIOPHONE" : props.subTileName,
            response.content
          );
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlert());
          setTimeout(() => {
            dispatch(hideAlert());
          }, 5000);
        }
        //setDownloadCsv(false);
      })
    );
  }
  return (
    <CustomCardView
      lmtdCheck={lmtdCheck}
      fetchCsvData={fetchCsvData}
      data={props.data}
      body={props.body}
      isCsvActive={props.isCsvActive}
      headerUnit={props.headerUnit}
      {...props}
    />
  );
};

export default CustomCard;
